import DeleteCommentDialog from "./DeleteCommentDialog";

export default DeleteCommentDialog